import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import Text from 'core/elements/Text'
import clsx from 'clsx'

const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    display: 'grid',
    gap: 8,
  },
  labelRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  label: {
    display: 'flex',
    gap: 4,
    alignItems: 'center',
  },
  endLabel: {
    display: 'grid',
    gridTemplateColumns: 'max-content max-content',
    gap: 4,
    alignItems: 'center',
  },
  graphContainer: {
    height: 16,
    width: '100%',
    background: theme.palette.grey[100],
    border: `1px solid ${theme.palette.grey[200]}`,
  },
  graph: {
    height: 16,
    position: 'relative',
    top: -1,
    left: -1,
  },
  graphLow: {
    background: theme.palette.graphGreen[100],
    border: `1px solid ${theme.palette.graphGreen[500]}`,
  },
  graphMedium: {
    background: theme.palette.graphYellow[100],
    border: `1px solid ${theme.palette.graphYellow[500]}`,
  },
  graphHigh: {
    background: theme.palette.graphRed[100],
    border: `1px solid ${theme.palette.graphRed[500]}`,
  },
}))

interface Props {
  label?: string
  unit?: string
  usage: number
  capacity: number
}

const getPercent = ({ usage, capacity }) => {
  if (!usage || !capacity) {
    return 0
  }
  if (capacity === -1) {
    return 0
  }
  const percent = usage / capacity
  return Math.round(percent * 10000) / 100
}

export default function ProgressGraph({ label, unit, usage, capacity }: Props) {
  const percent = getPercent({ usage, capacity })
  const classes = useStyles()
  const width = percent > 100 ? '100%' : `${percent}%`
  const graphClass =
    percent < 50 ? classes.graphLow : percent < 80 ? classes.graphMedium : classes.graphHigh

  return (
    <div className={classes.container}>
      {!!label && (
        <div className={classes.labelRow}>
          <div className={classes.label}>
            <Text variant="body1">
              <b>{label}</b>
              {!!unit && ` (${unit})`}
            </Text>
          </div>
          <div className={classes.endLabel}>
            <Text variant="subtitle2">
              {usage}
              {'/'}
              {capacity === -1 ? 'unlimited' : capacity}
            </Text>
            <Text variant="body1">({percent}%) used</Text>
          </div>
        </div>
      )}
      <div className={classes.graphContainer}>
        {percent > 0 && <div className={clsx(classes.graph, graphClass)} style={{ width }}></div>}
      </div>
    </div>
  )
}
